import {call, put, takeLatest} from "redux-saga/effects";
import * as actions from '../actions/auth';
import * as sessionActions from '../actions/session';
import * as actionTypes from '../actions/actionTypes';
import history from '../../history';
import {fetchUserByToken} from "../../api/user";
import {logout} from "../../api/auth";
import {TokenStorage} from "../../api/tokenStorage";
import {clearStorage} from "../../app/_helpers/LocalStorageHelpers";

export default function* authSaga() {

    /* Redirect to 2FA page after 2FA uuid received */
    yield takeLatest(actionTypes.TWO_FACTOR_UUID_REQUESTED, function* setUuidFactor() {
        yield history.push('/auth/2fa');
    });

    /* Redirect to root after 2FA validation is cancelled */
    yield takeLatest(actionTypes.CANCEL_TWO_FACTOR_VALIDATION, function* cancelTwoFactor() {
        yield history.push('/');
    });

    /* Fetch user data and save to Store */
    yield takeLatest(actionTypes.USER_REQUESTED, function* userRequested(action) {
        // fetch user data
        const {response, error} = yield call(fetchUserByToken);

        if (response) {
            const {data: {user, companies, modules, avatar}} = response.data;

            // save first company
            yield put(sessionActions.setCurrentCompanySession(companies[0], null, false));
            // save user profile
            yield put(actions.fulfillUser(user, avatar));
            // save user settings
            yield put(sessionActions.fulfillUserSettings(companies, modules));
        } else {
            yield history.push('/auth/2fa', {error : 'An error ocurred. Please try again'});
        }
    });

    /* Logout user and clear storage */
    yield takeLatest(actionTypes.AUTH_LOGOUT, function* logoutFactor() {
        yield logout();
        // clear local storage
        yield TokenStorage.clear();
        yield clearStorage();
    });
}
